<div class="sq-notifications">
    <sq-notification *ngFor="let notification of notifications" [notification]="notification"></sq-notification>
</div>